var map = {
	"./Adapt The Future.png": "./src/assets/images/Adapt The Future.png",
	"./BusinessImpacts.png": "./src/assets/images/BusinessImpacts.png",
	"./CallOfDissatisfaction.png": "./src/assets/images/CallOfDissatisfaction.png",
	"./Campaign-Management.png": "./src/assets/images/Campaign-Management.png",
	"./CustSatisfaction.png": "./src/assets/images/CustSatisfaction.png",
	"./CustVoice.png": "./src/assets/images/CustVoice.png",
	"./Customer-Acquisition.png": "./src/assets/images/Customer-Acquisition.png",
	"./Customer-Segmentation.png": "./src/assets/images/Customer-Segmentation.png",
	"./Data-Risk-Classification.png": "./src/assets/images/Data-Risk-Classification.png",
	"./DataSecurity.png": "./src/assets/images/DataSecurity.png",
	"./Dynamic-Pricing.png": "./src/assets/images/Dynamic-Pricing.png",
	"./EnterpriseReadinessRank.png": "./src/assets/images/EnterpriseReadinessRank.png",
	"./Housing-Market-Trends.png": "./src/assets/images/Housing-Market-Trends.png",
	"./Inspire Strategy.png": "./src/assets/images/Inspire Strategy.png",
	"./Live Your Purpose.png": "./src/assets/images/Live Your Purpose.png",
	"./Load-Factor-Management.png": "./src/assets/images/Load-Factor-Management.png",
	"./Operations-Surveillance.png": "./src/assets/images/Operations-Surveillance.png",
	"./OpsRiskSurveillance.png": "./src/assets/images/OpsRiskSurveillance.png",
	"./Originations-Trends.png": "./src/assets/images/Originations-Trends.png",
	"./Personalized-Product-Processor.png": "./src/assets/images/Personalized-Product-Processor.png",
	"./Prescriptive-Maintenance.png": "./src/assets/images/Prescriptive-Maintenance.png",
	"./Product-Personalization.png": "./src/assets/images/Product-Personalization.png",
	"./Readmission-Risk.png": "./src/assets/images/Readmission-Risk.png",
	"./Repayment-Performance-Trends.png": "./src/assets/images/Repayment-Performance-Trends.png",
	"./Resource-Optimization.png": "./src/assets/images/Resource-Optimization.png",
	"./Rising-Ahead-Name-Logo.png": "./src/assets/images/Rising-Ahead-Name-Logo.png",
	"./Route-Optimization.png": "./src/assets/images/Route-Optimization.png",
	"./Sales-Force-Effectiveness.png": "./src/assets/images/Sales-Force-Effectiveness.png",
	"./TechnologyAdoptionCurve.png": "./src/assets/images/TechnologyAdoptionCurve.png",
	"./TimelineToAdapt.png": "./src/assets/images/TimelineToAdapt.png",
	"./about-us.png": "./src/assets/images/about-us.png",
	"./accounting.png": "./src/assets/images/accounting.png",
	"./actuarial.png": "./src/assets/images/actuarial.png",
	"./acuverse-bg.png": "./src/assets/images/acuverse-bg.png",
	"./acuverse-logo.png": "./src/assets/images/acuverse-logo.png",
	"./acuverse.png": "./src/assets/images/acuverse.png",
	"./adapt-future-bg.png": "./src/assets/images/adapt-future-bg.png",
	"./adapt-the-future.png": "./src/assets/images/adapt-the-future.png",
	"./adaptive-decisions-bg.png": "./src/assets/images/adaptive-decisions-bg.png",
	"./adaptive-decisions.png": "./src/assets/images/adaptive-decisions.png",
	"./agnostic.png": "./src/assets/images/agnostic.png",
	"./analyses-data.png": "./src/assets/images/analyses-data.png",
	"./arrow-right.png": "./src/assets/images/arrow-right.png",
	"./arrow.png": "./src/assets/images/arrow.png",
	"./assetUtilizationOptimize.png": "./src/assets/images/assetUtilizationOptimize.png",
	"./athena-A.png": "./src/assets/images/athena-A.png",
	"./athena-circle.png": "./src/assets/images/athena-circle.png",
	"./athena-home-logo-bg.png": "./src/assets/images/athena-home-logo-bg.png",
	"./athena-home-logo.png": "./src/assets/images/athena-home-logo.png",
	"./autonomous.png": "./src/assets/images/autonomous.png",
	"./behavior-changes.png": "./src/assets/images/behavior-changes.png",
	"./bi.png": "./src/assets/images/bi.png",
	"./borrower-behavior.png": "./src/assets/images/borrower-behavior.png",
	"./business-challenges.png": "./src/assets/images/business-challenges.png",
	"./business-intelligence.png": "./src/assets/images/business-intelligence.png",
	"./business-strategy-bg.png": "./src/assets/images/business-strategy-bg.png",
	"./c-suite.png": "./src/assets/images/c-suite.png",
	"./care-access.png": "./src/assets/images/care-access.png",
	"./care-bg.png": "./src/assets/images/care-bg.png",
	"./care-coverage.png": "./src/assets/images/care-coverage.png",
	"./care-issues.png": "./src/assets/images/care-issues.png",
	"./care.png": "./src/assets/images/care.png",
	"./carousel-arrow-next.png": "./src/assets/images/carousel-arrow-next.png",
	"./carousel-arrow-prev.png": "./src/assets/images/carousel-arrow-prev.png",
	"./centralized.png": "./src/assets/images/centralized.png",
	"./claims.png": "./src/assets/images/claims.png",
	"./claimsEffectiveness.png": "./src/assets/images/claimsEffectiveness.png",
	"./clients-assess.png": "./src/assets/images/clients-assess.png",
	"./clients.png": "./src/assets/images/clients.png",
	"./cod.png": "./src/assets/images/cod.png",
	"./collateral-risks.png": "./src/assets/images/collateral-risks.png",
	"./collections.png": "./src/assets/images/collections.png",
	"./collectionsEffectiveness.png": "./src/assets/images/collectionsEffectiveness.png",
	"./complaince.png": "./src/assets/images/complaince.png",
	"./connect-icon.png": "./src/assets/images/connect-icon.png",
	"./consumer.png": "./src/assets/images/consumer.png",
	"./consumes-data.png": "./src/assets/images/consumes-data.png",
	"./cost-optimization-security.png": "./src/assets/images/cost-optimization-security.png",
	"./cost-optimization.png": "./src/assets/images/cost-optimization.png",
	"./credit-exposures.png": "./src/assets/images/credit-exposures.png",
	"./creditRiskMgmt.png": "./src/assets/images/creditRiskMgmt.png",
	"./crossSell.png": "./src/assets/images/crossSell.png",
	"./cust-CompliantMgmt.png": "./src/assets/images/cust-CompliantMgmt.png",
	"./custAdvocacy.png": "./src/assets/images/custAdvocacy.png",
	"./data-delivery.png": "./src/assets/images/data-delivery.png",
	"./data-management.png": "./src/assets/images/data-management.png",
	"./data-quality.png": "./src/assets/images/data-quality.png",
	"./data-services-gray.png": "./src/assets/images/data-services-gray.png",
	"./data-services.png": "./src/assets/images/data-services.png",
	"./data-transformation-bg.png": "./src/assets/images/data-transformation-bg.png",
	"./dataChange.png": "./src/assets/images/dataChange.png",
	"./dataLIfecycle.png": "./src/assets/images/dataLIfecycle.png",
	"./dataQuality.png": "./src/assets/images/dataQuality.png",
	"./dcm.png": "./src/assets/images/dcm.png",
	"./de.png": "./src/assets/images/de.png",
	"./decision-engine.png": "./src/assets/images/decision-engine.png",
	"./decision-intelligence.png": "./src/assets/images/decision-intelligence.png",
	"./discovers-patterns.png": "./src/assets/images/discovers-patterns.png",
	"./dlm.png": "./src/assets/images/dlm.png",
	"./dlp.png": "./src/assets/images/dlp.png",
	"./doorway-bg.png": "./src/assets/images/doorway-bg.png",
	"./doorway.png": "./src/assets/images/doorway.png",
	"./dpf.png": "./src/assets/images/dpf.png",
	"./drc.png": "./src/assets/images/drc.png",
	"./dsm.png": "./src/assets/images/dsm.png",
	"./dwm.png": "./src/assets/images/dwm.png",
	"./ecosystem-gray.png": "./src/assets/images/ecosystem-gray.png",
	"./ecosystems.png": "./src/assets/images/ecosystems.png",
	"./efficiency.png": "./src/assets/images/efficiency.png",
	"./email-icon.png": "./src/assets/images/email-icon.png",
	"./emerging-technologies-bg.png": "./src/assets/images/emerging-technologies-bg.png",
	"./emerging.png": "./src/assets/images/emerging.png",
	"./enterprise-readiness.png": "./src/assets/images/enterprise-readiness.png",
	"./enterprise.png": "./src/assets/images/enterprise.png",
	"./entrera-E.png": "./src/assets/images/entrera-E.png",
	"./entrera-bg.png": "./src/assets/images/entrera-bg.png",
	"./entrera-data-quality.png": "./src/assets/images/entrera-data-quality.png",
	"./entrera-logo.png": "./src/assets/images/entrera-logo.png",
	"./entrera.png": "./src/assets/images/entrera.png",
	"./err-slide-1.png": "./src/assets/images/err-slide-1.png",
	"./err-slide-2.png": "./src/assets/images/err-slide-2.png",
	"./err-slide-3.png": "./src/assets/images/err-slide-3.png",
	"./esg.png": "./src/assets/images/esg.png",
	"./facebook.png": "./src/assets/images/facebook.png",
	"./finance.png": "./src/assets/images/finance.png",
	"./find-me-my-flight.png": "./src/assets/images/find-me-my-flight.png",
	"./footer-bg.png": "./src/assets/images/footer-bg.png",
	"./fraud.png": "./src/assets/images/fraud.png",
	"./fuel-efficient-airlines.png": "./src/assets/images/fuel-efficient-airlines.png",
	"./functional-architecture.png": "./src/assets/images/functional-architecture.png",
	"./gerard-antony.png": "./src/assets/images/gerard-antony.png",
	"./growth-owners-icon.png": "./src/assets/images/growth-owners-icon.png",
	"./growth-owners.png": "./src/assets/images/growth-owners.png",
	"./hacc.png": "./src/assets/images/hacc.png",
	"./hybrid.png": "./src/assets/images/hybrid.png",
	"./increase-productivity.png": "./src/assets/images/increase-productivity.png",
	"./india-market.png": "./src/assets/images/india-market.png",
	"./information-owners-icon.png": "./src/assets/images/information-owners-icon.png",
	"./information-owners.png": "./src/assets/images/information-owners.png",
	"./innovation-ecosystem-bg.png": "./src/assets/images/innovation-ecosystem-bg.png",
	"./insanity-bg.png": "./src/assets/images/insanity-bg.png",
	"./inspire-strategy.png": "./src/assets/images/inspire-strategy.png",
	"./inspiring-strategy-bg.png": "./src/assets/images/inspiring-strategy-bg.png",
	"./inspiring-strategy.png": "./src/assets/images/inspiring-strategy.png",
	"./intelverse-small.png": "./src/assets/images/intelverse-small.png",
	"./intelverse.png": "./src/assets/images/intelverse.png",
	"./invest.png": "./src/assets/images/invest.png",
	"./investor.png": "./src/assets/images/investor.png",
	"./joanna-pasquale.png": "./src/assets/images/joanna-pasquale.png",
	"./learns-market.png": "./src/assets/images/learns-market.png",
	"./learns-patterns.png": "./src/assets/images/learns-patterns.png",
	"./lender-behavior.png": "./src/assets/images/lender-behavior.png",
	"./limitless.png": "./src/assets/images/limitless.png",
	"./linkedin-icon.png": "./src/assets/images/linkedin-icon.png",
	"./linkedin.png": "./src/assets/images/linkedin.png",
	"./live-your-purpose.png": "./src/assets/images/live-your-purpose.png",
	"./loanUnderwriting.png": "./src/assets/images/loanUnderwriting.png",
	"./logistics.png": "./src/assets/images/logistics.png",
	"./logo-large.png": "./src/assets/images/logo-large.png",
	"./logo.png": "./src/assets/images/logo.png",
	"./makes-business-decision.png": "./src/assets/images/makes-business-decision.png",
	"./manufacturing.png": "./src/assets/images/manufacturing.png",
	"./marketing.png": "./src/assets/images/marketing.png",
	"./marketplace-bg.png": "./src/assets/images/marketplace-bg.png",
	"./marketplace.png": "./src/assets/images/marketplace.png",
	"./master-dm.png": "./src/assets/images/master-dm.png",
	"./masterData.png": "./src/assets/images/masterData.png",
	"./mdm.png": "./src/assets/images/mdm.png",
	"./metaverse-small.png": "./src/assets/images/metaverse-small.png",
	"./metaverse.png": "./src/assets/images/metaverse.png",
	"./modalbg.png": "./src/assets/images/modalbg.png",
	"./modalclose.png": "./src/assets/images/modalclose.png",
	"./mp-growth-owners.png": "./src/assets/images/mp-growth-owners.png",
	"./mp-information-owners.png": "./src/assets/images/mp-information-owners.png",
	"./mp-operations-owners.png": "./src/assets/images/mp-operations-owners.png",
	"./mp-strategy-owners.png": "./src/assets/images/mp-strategy-owners.png",
	"./mp.png": "./src/assets/images/mp.png",
	"./mps.png": "./src/assets/images/mps.png",
	"./new-markets-gray.png": "./src/assets/images/new-markets-gray.png",
	"./new-markets.png": "./src/assets/images/new-markets.png",
	"./nexverse-small.png": "./src/assets/images/nexverse-small.png",
	"./nexverse.png": "./src/assets/images/nexverse.png",
	"./operations-efficiency.png": "./src/assets/images/operations-efficiency.png",
	"./operations-owners-icon.png": "./src/assets/images/operations-owners-icon.png",
	"./operations-owners.png": "./src/assets/images/operations-owners.png",
	"./operations.png": "./src/assets/images/operations.png",
	"./optimization.png": "./src/assets/images/optimization.png",
	"./patientBill.png": "./src/assets/images/patientBill.png",
	"./performanceMgmt.png": "./src/assets/images/performanceMgmt.png",
	"./portfolio.png": "./src/assets/images/portfolio.png",
	"./potential.png": "./src/assets/images/potential.png",
	"./pp.png": "./src/assets/images/pp.png",
	"./ppv.png": "./src/assets/images/ppv.png",
	"./process-digitalization.png": "./src/assets/images/process-digitalization.png",
	"./process-digitization.png": "./src/assets/images/process-digitization.png",
	"./product-opt.png": "./src/assets/images/product-opt.png",
	"./productivity.png": "./src/assets/images/productivity.png",
	"./rahul-arora.png": "./src/assets/images/rahul-arora.png",
	"./readiness-foundation.png": "./src/assets/images/readiness-foundation.png",
	"./readmissionRisk.png": "./src/assets/images/readmissionRisk.png",
	"./revenues.png": "./src/assets/images/revenues.png",
	"./risk-2.png": "./src/assets/images/risk-2.png",
	"./risk.png": "./src/assets/images/risk.png",
	"./rrm.png": "./src/assets/images/rrm.png",
	"./saas-bg.png": "./src/assets/images/saas-bg.png",
	"./saas.png": "./src/assets/images/saas.png",
	"./safety.png": "./src/assets/images/safety.png",
	"./sales-cp.png": "./src/assets/images/sales-cp.png",
	"./sales.png": "./src/assets/images/sales.png",
	"./securverse-small.png": "./src/assets/images/securverse-small.png",
	"./securverse.png": "./src/assets/images/securverse.png",
	"./self-assess-icon.png": "./src/assets/images/self-assess-icon.png",
	"./self-service.png": "./src/assets/images/self-service.png",
	"./service.png": "./src/assets/images/service.png",
	"./servicer-trends.png": "./src/assets/images/servicer-trends.png",
	"./sfe.png": "./src/assets/images/sfe.png",
	"./signup.png": "./src/assets/images/signup.png",
	"./smart-data-bg.png": "./src/assets/images/smart-data-bg.png",
	"./smart.png": "./src/assets/images/smart.png",
	"./spdm.png": "./src/assets/images/spdm.png",
	"./splashlogo.png": "./src/assets/images/splashlogo.png",
	"./strategy-owners-icon.png": "./src/assets/images/strategy-owners-icon.png",
	"./strategy-owners.png": "./src/assets/images/strategy-owners.png",
	"./strengthen-foundation.png": "./src/assets/images/strengthen-foundation.png",
	"./supply-cp.png": "./src/assets/images/supply-cp.png",
	"./survellience.png": "./src/assets/images/survellience.png",
	"./sustainability.png": "./src/assets/images/sustainability.png",
	"./tech-adoption.png": "./src/assets/images/tech-adoption.png",
	"./technical.png": "./src/assets/images/technical.png",
	"./time-is-now.png": "./src/assets/images/time-is-now.png",
	"./us1.png": "./src/assets/images/us1.png",
	"./us2.png": "./src/assets/images/us2.png",
	"./us3.png": "./src/assets/images/us3.png",
	"./video.png": "./src/assets/images/video.png",
	"./videoBG-Entrera.png": "./src/assets/images/videoBG-Entrera.png",
	"./workforce.png": "./src/assets/images/workforce.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/images sync recursive ^\\.\\/.*\\.png$";